export const BASE_URL = 'https://quizappapi.vidyaglobe.com'
// export const BASE_URL = 'http://192.168.31.101:3007'
// export const EDITOR_API_KEY='6nkfwttj8ia921j1oqyzei5aygt3ohxhbvxjyr2ex1rpor3j'
// 6nkfwttj8ia921j1oqyzei5aygt3ohxhbvxjyr2ex1rpor3j
